import { dteTestRequirementApi } from "../../api";

const DteTestRequirementService = {
    /**
     * Obtener la lista de requisitos de pruebas activos.
     */
    listActive: async () => {
        try {
            const response = await dteTestRequirementApi.fetchAll();
            return response.data;
        } catch (error: any) {
            throw error;
        }
    }
};

export default DteTestRequirementService;
